import React, {useEffect, useState } from "react"
import { Modal, Table } from "antd"
import styles from "./index.module.css"
import { DownloadOutlined } from "@ant-design/icons"

export const DownloadDocumentModal = ({ recordData, open, onCancel }) => {
  const [fileList, setFileList] = useState([])
  const [pdfUrls, setPdfUrls] = useState([])
  const columns = [
    {
      title: "Document Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text || "document.pdf"
    },
    {
      title: "Signed on",
      dataIndex: "signedDate",
      key: "signedDate",
      render: (text, record) => {
        // Extract date from the signed document if available
        const signedDoc = recordData?.signed_documents?.[record.index]
        return signedDoc?.signed_at || "N/A"
      }
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <DownloadOutlined
          className={styles.downloadIcon}
          onClick={() => {
            const link = document.createElement("a")
            link.href = pdfUrls[record.index]
            link.download = record.name || `document-${record.index + 1}.pdf`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }}
        />
      )
    }
  ]
  useEffect(() => {
    const waivers = recordData?.signed_documents || []
    if (waivers.length > 0) {
      const now = new Date()
      const initialFileObjects = waivers.map((waiverItem, index) => {
        const fileName = waiverItem?.split("/").pop() || "document.pdf"
        return {
          uid: `existing-${Date.now()}-${index}`,
          lastModified: now.getTime(),
          lastModifiedDate: now.toISOString(),
          name: fileName,
          type: "application/pdf",
          percent: 0,
          status: "uploading",
          url: waiverItem.document_url,
          index: index,
          key: index
        }
      })

      setFileList(initialFileObjects)

      // Load all documents
      const fetchDocuments = async () => {
        try {
          const filePromises = waivers.map(async (waiverItem, index) => {
            const fileName = waiverItem?.split("/").pop() || "document.pdf"

            const response = await fetch(waiverItem)
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }

            // Get the blob and create a file object
            const blob = await response.blob()
            const file = new File([blob], fileName, {
              type: blob.type || "application/pdf",
              lastModified: now.getTime()
            })

            // Create the final file object with all properties
            return {
              ...initialFileObjects[index],
              size: blob.size,
              status: "done",
              originFileObj: file,
              index: index,
              key: index
            }
          })

          const fileObjects = await Promise.all(filePromises)
          setFileList(fileObjects)

          // Set PDF URLs for all documents
          const pdfObjectUrls = fileObjects.map((fileObj) => URL.createObjectURL(fileObj.originFileObj))
          setPdfUrls(pdfObjectUrls)

          // Clean up function to revoke object URLs on unmount
          return () => {
            pdfObjectUrls.forEach((url) => URL.revokeObjectURL(url))
          }
        } catch (error) {
          console.error("Error fetching documents:", error)
          // Update file list with error state
          setFileList(
            initialFileObjects.map((obj) => ({
              ...obj,
              status: "error",
              error: "Failed to load document"
            }))
          )
        }
      }
      fetchDocuments()
    }
  }, [recordData?.signed_documents])

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={600} maskClosable={false}>
      <>
        {/* Documents Table */}
        <Table columns={columns} dataSource={fileList} pagination={false} size="small" loading={fileList.length === 0} rowKey="key" />
      </>
    </Modal>
  )
}
